import { render } from "./TextNotification.vue?vue&type=template&id=a3375f24"
import script from "./TextNotification.vue?vue&type=script&lang=js"
export * from "./TextNotification.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__